import { AppBar, Stack, Toolbar, Typography, styled } from "@mui/material";
import { Link } from "react-router-dom";
import HeaderProfileDropdown from "./HeaderProfileDropdown";

const MeadacheAppBar = styled(AppBar)({
  color: "white",
});

const HeaderLink = styled(Link)({
  color: "inherit",
  textDecoration: "none",
  transition: "color 0.2s",
  "&:hover": {
    color: "lightgrey", // You can use any color you prefer
  },
});

const Header = () => (
  <header>
    <MeadacheAppBar position="static">
      <Toolbar>
        <Stack direction="row" spacing={4} flexGrow={1} alignItems="center">
          <Typography variant="h6" component="div">
            <HeaderLink to="/">Meadache</HeaderLink>
          </Typography>
        </Stack>

        <Stack direction="row" spacing={4} alignItems="center">
          <Typography variant="body1" component="div">
            <HeaderLink to="questions">Questions</HeaderLink>
          </Typography>
          <Typography variant="body1" component="div">
            <HeaderLink to="calculators">Calculators</HeaderLink>
          </Typography>
          <Typography variant="body1" component="div">
            <HeaderLink to="red-flags">Red flags checklist</HeaderLink>
          </Typography>
          <HeaderProfileDropdown />
        </Stack>
      </Toolbar>
    </MeadacheAppBar>
  </header>
);

export default Header;
